import { DataSource, Image, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiProfileOrderQuickInfo extends Layout {
    labelPartnerNotes: Label;
    labelPartnerNotesImage: Label;
    linkToClassic: Image;
    panel1: Panel;
    panel2: Panel;
    panel3: Panel;
    panel4: Panel;
    panel5: Panel;
    sourceEdiorderProfile: DataSource;
    textboxAltPartnerId: Textbox;
    textboxFuncReceiverId: Textbox;
    textboxFuncSenderId: Textbox;
    textboxIntReceiverId: Textbox;
    textboxIntSenderId: Textbox;
    textboxPartnerId: Textbox;
    textboxTemplateId: Textbox;
    textboxVersion: Textbox;
}
